import { RegisterUnmatchedOrderBusinessRequest } from '@/coreInfrastructureModule/axios/generated/unmatchedOrderManage';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { OrderBusinessForRegister } from '../domains/entities/UnmatchedOrderItem';

/**
 * APIレスポンスをUI表示用のUnmatchedOrderItemに変換する
 */
export class RegisterUnmatchedOrderBusinessAdapter {
  /**
   * OrderBusinessForRegisterをRegisterUnmatchedOrderBusinessRequestに変換する
   * @param info - 登録用の発注取引情報
   */
  public static adapt(info: OrderBusinessForRegister): RegisterUnmatchedOrderBusinessRequest {
    const res: RegisterUnmatchedOrderBusinessRequest = {
      // 集計情報
      warehouseNumber: info.warehouseNumber,
      warehouse: info.warehouse,
      supplierNumber: info.supplierNumber,
      supplierName: info.supplierName,
      businessNumber: info.businessNumber,
      businessName: info.businessName,
      package: info.package,
      unit: info.unit,
      manufacturer: info.manufacturer,
      aggregateBusinessResponsibleUserIdList: info.aggregateBusinessResponsibleUser?.map((u) => u.email).filter((uid) => uid != null) ?? [],
      userUniqueNumber: info.userUniqueNumber,
      leadTime: info.leadTime,
      leadTimeUnit: info.leadTimeUnit || 'day',
      stdInventoryIndexMax: info.stdInventoryIndexMax,
      stdInventoryIndexMin: info.stdInventoryIndexMin,
      stdInventoryIndexUnit: info.stdInventoryIndexUnit || 'day',
      moq: info.moq,
      orderPackage: info.orderPackage,
      // 発注情報
      orderNumber: info.orderNumber,
      createdOrderDate: info.createdOrderDate ? DateService.formatIDateToISOString(info.createdOrderDate) : undefined,
      desiredDeliveryDate: DateService.formatIDateToISOString(info.desiredDeliveryDate),
      estimatedTimeOfArrival: DateService.formatIDateToISOString(info.estimatedTimeOfArrival),
      orderAmount: info.orderAmount,
      orderStatus: info.orderStatus,
      // 未照合発注情報
      unmatchedOrderId: info.unmatchedOrderId,
    };
    return res;
  }
}
